import { Resource } from 'model/Resource';
import { Selector } from 'reselect';
import { SurveyState } from 'store/SurveyState';
import { Meta } from 'model/Meta';

import { createResourceContentSelector } from './resourceSelector';

export const selectMetaResource: Selector<SurveyState, Resource<Meta>> = (state) =>
  state?.metaResource || Resource.void<Meta>();

export const selectMeta = createResourceContentSelector(selectMetaResource);
